<template>
  <div class="brand">
    <h2>{{title}}</h2>
    <p>{{subTitle}}</p>
    <el-row :gutter="51">
      <el-col v-for="(item, index) in brandList" :key="index">
        <img :src="item.logo" alt />
      </el-col>
    </el-row>
  </div>
</template>
<script>
const brandConfigUri = "website/index/brand/conf/detail";
const brandListUri = "website/index/brand/get/all";

export default {
  data() {
    return {
      title: "",
      subTitle: "销巴期待您的加入",
      brandList: []
    };
  },
  created() {
    this.initBrandConfig();
    this.getBrandList();
  },
  methods: {
    initBrandConfig() {
      this.$api.get(brandConfigUri).then(res => {
        this.title = res.title;
      });
    },
    getBrandList() {
      this.$api.get(brandListUri).then(res => {
        this.brandList = res.list;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.brand {
  width: 1200px;
  margin: 0 auto;
  padding: 48px;
  background: #fff;
  margin-top: 37px;
  h2 {
    font-size: 30px;
    color: #333;
    font-weight: 500;
    line-height: 45px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #555555;
    margin-top: 6px;
  }
  .el-row {
    .el-col {
      margin-top: 40px;
      width: 180px;
      height: 70px;
      box-sizing: content-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



